<div class="">

  <div class="col-md-12">

    <div class="row">
      <div class="col-md-6 text-left">
      <h3 class="primary-color">خطوط النقل</h3>
      </div>
      <div class="col-md-6 ml-auto">
        <button type="button" class="btn btn-outline-secondary mr-2  dashed-button" data-toggle="modal" data-target="#myModal"  > + إضافة خط نقل</button>
        <button type="button" class="btn btn-outline-secondary  dashed-button" (click)="changeView()" >
        {{!tableView?'عرض على شكل جداول':'عرض  بشكل مفصل'}}
        </button>
      </div>

    </div>
    <div class="row">
      <div class="col-md-9">
        <div class="input-group mb-3">
          <div class="input-icons">
            <i class="fa fa-search icon">
            </i>
            <input type="text" #searchText (keyup)="($event)" class="form-control transparent" placeholder="بحث في الرحلات" aria-label="Recipient's username" aria-describedby="basic-addon2">
            <i class="fa fa-times-circle pointer left" *ngIf="searchText.value.length>0" (click)="removeSearch()"></i>

          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="row" *ngIf="loader">
    <div class="col-md-12">
      <div class="text-center">
        <div class="loader"></div>
      </div>
    </div>
  </div>
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" id="home-tab" data-toggle="tab" href="#go" role="tab" aria-controls="home" aria-selected="true">

    رحلات الذهاب
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="profile-tab" data-toggle="tab" href="#back" role="tab" aria-controls="profile" aria-selected="false">
        رحلات العودة


      </a>
    </li>
  </ul>

  <div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active" id="go" role="tabpanel" aria-labelledby="home-tab">
  <div class="row" >
    <div class="col-md-12" *ngIf="!tableView;else tableViewGoDiv">
      <div class="row" *ngFor="let travel of travels|search: 'travel_start_name' : searchText.value">
        <div class="col-md-12 ">

          <div class="bg-white pb-2">
            <div class="row mb-0 pb-0">
              <div class="col-md-12">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item no-line ml-2 "><img src="../../assets/images/icons/home.svg"/></li>
                    <li class="breadcrumb-item no-line" > {{travel['travel_start_name']}}   </li>
                    <li class="breadcrumb-item no-line" > <img src="../../assets/images/icons/arrow.svg"/> </li>
                    <li class="breadcrumb-item no-line" > <img src="../../assets/images/icons/gps.svg"> </li>
                    <li class="breadcrumb-item no-line" > {{travel['travel_end_name']}} </li>
                    <li class="breadcrumb-item no-line" > ({{travel['way']=='go'?'ذهاب':'عودة'}}) </li>
                    <li class="ml-auto" >

                      <div class="d-flex flex-row">
                        <div>
                          <button data-target="#assigneBus" data-toggle="modal"  (click)="getAssignBus(travel._id)" type="button" class="btn background-blue-g w-194 radius-16   "  >تعيين حافلة</button>

                        </div>
                        <div>
                          <i data-toggle="modal" (click)="selectedRow(travel)"  data-target="#mapView" class="fa fa-map pointer primary-color"></i>
                        </div>
                        <div class="dropdown">
                          <i class="fa fa-ellipsis-h text-black-50 pointer" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>

                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#myModal" (click)="getTravel(travel._id)">تعديل</a>
                            <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#deleteModal" (click)="selectedRow(travel)">حذف</a>

                          </div>
                        </div>

                      </div>


                    </li>

                  </ol>

                </nav>
              </div>
            </div>
            <div class="col-md-12">


<div class="row mt-0 pt-0">
  <div class="col-md-4 text-left">
    <span class="trip-text">نقاط التوقف</span>
  </div>

</div>
              <div class="row text-left">
                <div class="col-md-3 col-xl-3 col-lg-3 mb-2 p-0 box-border"  *ngFor="let way of travel.way_points">
                  <div class="row m-0  pt-1">
                    <div class="col-md-12">
                      <img src="../../assets/images/icons/home.svg" class="mr-2" width="20">
                      <span class="font-12 bold">{{way.label}}</span>
                    </div>
                  </div>
                  <div class="row m-0 pb-2">
                    <div class="col-md-12">
                      <span class="font-12 bold"><img src="../../assets/images/icons/time.svg" class="mr-2"/>{{way.time}}</span>

                    </div>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class="col-md-12 text-left">
                  <span class="trip-text">أيام العمل على الخط</span>
                </div>
              </div>
            <div class="row ">
              <div class="col-md-12  d-flex flex-row">
                <div class="small-box mr-2" *ngFor="let day of travel.work_days">
                  <span>{{days[day]}}</span>
                </div>

              </div>


            </div>

              <div class="row">
                <div class="col-md-12 text-left">
                  <span class="trip-text">الحافلات على الخط</span>
                </div>
              </div>
              <div class="row ">
                <div class="col-md-12  d-flex flex-row">
                  <div class="small-box mr-2" *ngFor="let bus of travel.bus">
                    <span>{{bus["bus_identity"]}}</span>
                  </div>

                </div>


              </div>

<!--              <app-map></app-map>-->


            </div>
          </div>

        </div>
      </div>


    </div>
  </div>
  <div class="col-md-12">
    <ng-template #tableViewGoDiv >
      <div class="col-md-12" *ngFor="let travel of travels|search: 'name' : search.value;let i=index">
        <div class="col-md-12 ">

          <div class="bg-white pb-2">
            <div class="row mb-0 pb-0">
              <div class="col-md-12">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item no-line" > {{travel['travel_start_name']}}   </li>
                    <li class="breadcrumb-item no-line" > <img src="../../assets/images/icons/arrow.svg"/> </li>
                    <li class="breadcrumb-item no-line" > {{travel['travel_end_name']}} </li>
                    <li class="ml-auto" >
                      <div class="dropdown">
                        <i class="fa fa-ellipsis-h text-black-50 pointer" (click)="selectedRow(travel)" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>

                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#myModal" (click)="getTravel(travel._id)">تعديل</a>
                          <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#deleteModal" (click)="selectedRow(travel)">حذف</a>
                          <a class="dropdown-item border-bottom"  (click)="print(i)">طباعة</a>

                        </div>
                      </div>


                    </li>
                  </ol>

                </nav>
              </div>
            </div>
            <div class="row" id="travel-{{i}}">
              <div class="col-md-12">
                <table class="table table-bordered"  >
                  <thead>
                  <tr>
                    <th class="red">نقاط التوقف</th>
                    <th class="red">وقت الوصول</th>
                  </tr>

                  </thead>
                  <tbody>
                  <tr *ngFor="let way of travel['way_points']">
                    <td>
                      {{way.label}}
                    </td>
                    <td>
                      {{way.time}}
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </ng-template>
  </div>
    </div>
    <div class="tab-pane" id="back" role="tabpanel" aria-labelledby="back-tab">
      <div class="row" >
        <div class="col-md-12" *ngIf="!tableView;else tableViewDiv">
          <div class="row" *ngFor="let travel of backTravels|search: 'travel_start_name' : searchText.value">
            <div class="col-md-12 ">

              <div class="bg-white pb-2">
                <div class="row mb-0 pb-0">
                  <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                      <ol class="breadcrumb">
                        <li class="breadcrumb-item no-line ml-2 "><img src="../../assets/images/icons/home.svg"/></li>
                        <li class="breadcrumb-item no-line" > {{travel['travel_start_name']}}   </li>
                        <li class="breadcrumb-item no-line" > <img src="../../assets/images/icons/arrow.svg"/> </li>
                        <li class="breadcrumb-item no-line" > <img src="../../assets/images/icons/gps.svg"> </li>
                        <li class="breadcrumb-item no-line" > {{travel['travel_end_name']}} </li>
                        <li class="breadcrumb-item no-line" > ({{travel['way']=='go'?'ذهاب':'عودة'}}) </li>
                        <li class="ml-auto" >

                          <div class="d-flex flex-row">
                            <div>
                              <button data-target="#assigneBus" data-toggle="modal"  (click)="getAssignBus(travel._id)" type="button" class="btn background-blue-g w-194 radius-16   "  >تعيين حافلة</button>

                            </div>
                            <div>
                              <i data-toggle="modal" (click)="selectedRow(travel)"  data-target="#mapView" class="fa fa-map pointer primary-color"></i>
                            </div>
                            <div class="dropdown">
                              <i class="fa fa-ellipsis-h text-black-50 pointer" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>

                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#myModal" (click)="getTravel(travel._id)">تعديل</a>
                                <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#deleteModal" (click)="selectedRow(travel)">حذف</a>

                              </div>
                            </div>

                          </div>


                        </li>

                      </ol>

                    </nav>
                  </div>
                </div>
                <div class="col-md-12">


                  <div class="row mt-0 pt-0">
                    <div class="col-md-4 text-left">
                      <span class="trip-text">نقاط التوقف</span>
                    </div>

                  </div>
                  <div class="row text-left">
                    <div class="col-md-3 col-xl-3 col-lg-3 mb-2 p-0 box-border"  *ngFor="let way of travel.way_points">
                      <div class="row m-0  pt-1">
                        <div class="col-md-12">
                          <img src="../../assets/images/icons/home.svg" class="mr-2" width="20">
                          <span class="font-12 bold">{{way.label}}</span>
                        </div>
                      </div>
                      <div class="row m-0 pb-2">
                        <div class="col-md-12">
                          <span class="font-12 bold"><img src="../../assets/images/icons/time.svg" class="mr-2"/>{{way.time}}</span>

                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-12 text-left">
                      <span class="trip-text">أيام العمل على الخط</span>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-md-12  d-flex flex-row">
                      <div class="small-box mr-2" *ngFor="let day of travel.work_days">
                        <span>{{days[day]}}</span>
                      </div>

                    </div>


                  </div>

                  <div class="row">
                    <div class="col-md-12 text-left">
                      <span class="trip-text">الحافلات على الخط</span>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-md-12  d-flex flex-row">
                      <div class="small-box mr-2" *ngFor="let bus of travel.bus">
                        <span>{{bus["bus_identity"]}}</span>
                      </div>

                    </div>


                  </div>

                  <!--              <app-map></app-map>-->


                </div>
              </div>

            </div>
          </div>


        </div>
      </div>
      <div class="col-md-12">
        <ng-template #tableViewDiv >
          <div class="col-md-12" *ngFor="let travel of backTravels|search: 'name' : search.value;let i=index">
            <div class="col-md-12 ">

              <div class="bg-white pb-2">
                <div class="row mb-0 pb-0">
                  <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                      <ol class="breadcrumb">
                        <li class="breadcrumb-item no-line" >   {{travel['travel_start_name']}}   </li>
                        <li class="breadcrumb-item no-line" > <img src="../../assets/images/icons/arrow.svg"/> </li>
                        <li class="breadcrumb-item no-line" > {{travel['travel_end_name']}} </li>
                        <li class="ml-auto" >
                          <div class="dropdown">
                            <i class="fa fa-ellipsis-h text-black-50 pointer" (click)="selectedRow(travel)" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>

                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#myModal" (click)="getTravel(travel._id)">تعديل</a>
                              <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#deleteModal" (click)="selectedRow(travel)">حذف</a>
                              <a class="dropdown-item border-bottom"  (click)="print(i)">طباعة</a>

                            </div>
                          </div>


                        </li>
                      </ol>

                    </nav>
                  </div>
                </div>
                <div class="row" id="travel-{{i}}">
                  <div class="col-md-12">
                    <table class="table table-bordered"  >
                      <thead>
                      <tr>
                        <th class="red">نقاط التوقف</th>
                        <th class="red">وقت الوصول</th>
                      </tr>

                      </thead>
                      <tbody>
                      <tr *ngFor="let way of travel['way_points']">
                        <td>
                          {{way.label}}
                        </td>
                        <td>
                          {{way.time}}
                        </td>
                      </tr>
                      </tbody>

                    </table>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </ng-template>
      </div>
    </div>


</div>

<!-- Trigger the modal with a button -->

<!-- Modal -->
<div class="modal fade" id="myModal"  tabindex='-1'role="dialog">
  <div class="modal-dialog" >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title ">{{editMode?"تعديل":"إضافة"}} خط نقل</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <form [formGroup]="data">
          <div class="row"><div class="col-md-12"><span class="trip-text">اسم خط النقل</span></div></div>
          <div class="row">
            <div class="col-md-6">
              <label>اسم مكان الانطلاق</label>

              <input type="text" formControlName="travel_start_name" placeholder="اسم مكان الانطلاق" class="form-control">
            </div>
            <div class="col-md-6">
              <label>اسم مكان الوصول</label>

              <input type="text" formControlName="travel_end_name" placeholder="اسم مكان الوصول" class="form-control">
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-4">
             <span class="trip-text">اتجاه سير الرحلة:</span>
            </div>
            <div class="col-md-4">
              <div class="  ">
                <input id="radio-1" formControlName="way" value="go" name="way" class="w-20 mr-2" type="radio" checked>
                <span for="radio-1" class="">رحلة ذهاب</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="  ">
                <input id="radio-2" formControlName="way" value="back" name="way" class="w-20 mr-2" type="radio">
                <span for="radio-2" class="">رحلة عودة</span>
              </div>


            </div>
          </div>
          <div class="row">

            <div class="col-md-6">
             <p class="trip-text"> نقاط التوقف</p>
            </div>
            <div class="col-md-6 ml-auto">
              <button type="button" class="btn btn-outline-secondary  dashed-button" (click)="addWayPoint()" > + إضافة  نقطة توقف</button>
            </div>


          </div>
<!--          style="max-height: 215px;overflow: scroll;"-->
          <div class="row" >
            <div class="col-md-12" formArrayName="way_points">





              <div class="row" *ngFor="let itemrow of data['controls']['way_points']['controls']; let i=index"
                   [formGroupName]="i">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-body p-0">
                        <div class="row p-0 m-0">
                          <div class="col-md-12 text-right p-0 m-0">
<span>
                            <i class="fa fa-minus-circle red pointer" style="font-size: 12px" *ngIf="data.controls.way_points.controls.length >0" (click)="deleteWayPoint(i)"></i>
</span>
                          </div>
                        </div>
                        <div class="row p-0 m-0 mb-2">
                          <div class="col-md-5">
                            <label>اسم النقطة</label>

                            <input type="text" formControlName="label" placeholder="اسم النقطة" class="form-control">

                          </div>
                          <div class="col-md-5">
                            <label>وقت الوصول</label>
                            <input type="time" formControlName="time" class="form-control"/>
                          </div>
                          <div class="col-md-2">
                            <label>الموقع</label>

                            <i [ngClass]="buttonClasses(i)" (click)="openMapModal(i)" data-target="#map" data-toggle="modal"  ></i>
                          </div>


                        </div>
<!--                        <div class="row p-0 m-0 mb-2">-->
<!--                          <div class="col-md-6">-->
<!--                            <label>lat  إحداثيات النقطة</label>-->

<!--                            <input type="text" value="" (click)="openMapModal(i)" data-target="#map" data-toggle="modal" formControlName="lat" placeholder="إحداثيات النقطة lat" class="form-control">-->
<!--&lt;!&ndash;                            <input type="text" value="" formControlName="lat" placeholder="إحداثيات النقطة lat" class="form-control">&ndash;&gt;-->

<!--                          </div>-->
<!--                          <div class="col-md-6">-->
<!--                            <label>lng  إحداثيات النقطة</label>-->

<!--                            <input type="text" value="" (click)="openMapModal(i)" data-target="#map" data-toggle="modal" formControlName="lng" placeholder="lng إحداثيات النقطة" class="form-control">-->

<!--                          </div>-->

<!--                        </div>-->
                      </div>
                    </div>

                  </div>

              </div>
          </div>
          </div>

          <div class="row" >

            <div class="col-md-6">
              <p class="trip-text">حدد أيام العمل على الخط</p>
            </div>


          </div>
          <div formGroupName="work_days">
            <div class="row text-black-50">
              <div class="col-md-3">
                <input id="cbx2" formControlName="sunday" class="w-20" type="checkbox"/>
                <span class="ml-2">الأحد</span>

              </div>
              <div class="col-md-3">
                <input id="cbx3" formControlName="monday" class="w-20" type="checkbox"/>
                <span class="ml-2">الإثنين</span>

              </div>
              <div class="col-md-3">
                <input id="cbx1" formControlName="tuesday" class="w-20" type="checkbox"/>
                <span class="ml-2">الثلاثاء</span>

              </div>
              <div class="col-md-3">
                <input id="cbx2" formControlName="wednesday" class="w-20" type="checkbox"/>
                <span class="ml-2">الأربعاء</span>

              </div>
            </div>
            <div class="row text-black-50">

              <div class="col-md-3">
                <input id="cbx3" formControlName="thursday" class="w-20" type="checkbox"/>
                <span class="ml-2">الخميس</span>

              </div>
              <div class="col-md-3">
                <input id="cbx3" formControlName="friday" class="w-20" type="checkbox"/>
                <span class="ml-2">الجمعة</span>

              </div>
              <div class="col-md-3">
                <input id="cbx3" formControlName="saturday" class="w-20" type="checkbox"/>
                <span class="ml-2">السبت</span>

              </div>

            </div>

          </div>



        </form>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button"  style="width:280px" [disabled]="!data.valid" class="btn radius-16  background-blue-g pr-5 pl-5" data-dismiss="modal" (click)="editMode?edit():add()">{{editMode?"تعديل":"إضافة"}} خط النقل</button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal  fade" id="deleteModal" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content   radius-16" style="width: 600px">
      <div class="modal-header background-red">
        <h4 class="modal-title">حذف  خط النقل</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <div class="row">
          <div class=" container text-center">
            <p class="text-black ">
              هل أنت متأكد من رغبتك في حذف خط ( {{rowSelected['travel_start_name']}} --> {{rowSelected['travel_end_name']}} ) ، سيتم حذف جميع الرحلات التي قام الطلبة بجدولتها على هذا الخط
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="text-center">
              <button type="button" class="btn radius-16    background-red   pr-5 pl-5" data-dismiss="modal" (click)="removeTravel(rowSelected['_id'])">نعم</button>

            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <button type="button"  class="btn  border background-white   pr-5 pl-5"  data-dismiss="modal" aria-label="Close">
                لا
              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal fade" id="assigneBus" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">تعيين حافلة للرحلة</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <div class="row">
          <div class="col-md-12">
            يتم عرض الحافلات التي تم تعيين سائق لها
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="input-group mb-3">
              <div class="input-icons">

                <input #search2 type="text" (keyup)="($event)" class="form-control transparent" placeholder="بحث " aria-label="Recipient's username" aria-describedby="basic-addon2">
                <i class="fa fa-search icon">
                </i>
              </div>
            </div>
          </div>
        </div>
        <table class="table no-border">

          <tbody>
          <tr *ngFor="let row of buses|search: 'name' : search2.value;let i=index">
            <th scope="row"  class="no-border" width="75%">
              <div class="media align-items-center">
                <a href="javascript:void(0)" class="avatar rounded-circle mr-3">
                  <img src="../../assets/images/icons/busFront.svg" width="21" id="" class="  " height="27"/>

                </a>
                <div class="" >
                  <span class="mb-0 text-sm">{{row.bus_identity}}</span>
                </div>
              </div>
            </th>
            <td class="no-border text-right">

              <div class="custom-radios">
                <div>
                  <input (click)="assignToBus(row._id,tripAssignBus.bus?tripAssignBus.bus.includes(row._id):false)" type="checkbox" [checked]="tripAssignBus.bus?tripAssignBus.bus.includes(row._id):false" id="color-1{{i}}" name="color"  class="checkbox " value="color-1">
                  <label for="color-1{{i}}">
      <span class="background-blue-g">
        <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/242518/check-icn.svg" alt="Checked Icon" />
      </span>
                  </label>
                </div>
              </div>
            </td>

          </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button" data-dismiss="modal"  style="width:280px" class="btn radius-16  background-blue-g pr-5 pl-5"  (click)="assignToBusApi()">حفظ الإضافات</button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal fade" id="map" tabindex='-1' role="dialog">
  <div class="modal-dialog modal-lg" >

    <!-- Modal content-->
    <div class="modal-content ">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">
          {{rowSelected['travel_start_name']}} - {{rowSelected['travel_end_name']}}


        </h4>
        <span class="modal-title pull-left"><i data-dismiss="modal" data-target="#map"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class=" text-left">

        <div class="">
          <div class=" p-0">
            <div class="form-group">
              <input placeholder="بحث"  autocapitalize="off" spellcheck="off" type="text" class="form-control" #search [formControl]="searchControl" >
            </div>
            <agm-map
              [latitude]="lat"
              [longitude]="lng"
              [zoom]="zoom"
              [disableDefaultUI]="false"
              [zoomControl]="true"
              (mapClick)="mapClicked($event)"
              >

              <agm-marker
                *ngFor="let m of markers; let i = index"
                [latitude]="m.lat"
                [longitude]="m.lng"
                [label]="m.label"
                [markerDraggable]="true"
                (dragEnd)="markerDragEnd($event)"
           >

<!--                <agm-info-window>-->
<!--                  <strong>InfoWindow content</strong>-->
<!--                </agm-info-window>-->

              </agm-marker>


            </agm-map>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button" data-dismiss="modal"  style="width:280px" class="btn radius-16  background-blue-g pr-5 pl-5"  (click)="addPointLocation()">حفظ </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal fade" id="mapView" tabindex='-1' role="dialog">
  <div class="modal-dialog modal-lg" >

    <!-- Modal content-->
    <div class="modal-content ">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title" *ngIf="rowSelected['travel_start_name']?rowSelected['travel_start_name'].length>0:false">
          {{rowSelected['travel_start_name']}} - {{rowSelected['travel_end_name']}}
        </h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class=" text-left">

        <div class="">
          <div class="">
            <agm-map
              [latitude]="lat"
              [longitude]="lng"
              [zoom]="zoom"
              [disableDefaultUI]="false"
              [zoomControl]="true"

            >

              <agm-marker
                *ngFor="let m of rowSelected['way_points']; let i = index"
                [latitude]="m.lat"
                [longitude]="m.lng"
           >

                <agm-info-window [isOpen]="true">
                  <strong>{{m.label}}</strong>
                </agm-info-window>

              </agm-marker>


            </agm-map>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>



